import { Component, OnInit } from '@angular/core';
import { IonicModule, LoadingController, ModalController, NavParams } from '@ionic/angular';
import { MeusGruposMinisteriosPage } from '../grupo/meus-grupos-ministerios/meus-grupos-ministerios.page';
import { MinhasContribuicoesPage } from '../minhas-contribuicoes/minhas-contribuicoes.page';
import { ModalPessoaFamiliaresPage } from '../modal-pessoa/modal-pessoa-familiares/modal-pessoa-familiares.page';
import { PessoaProjetosEnsinosPage } from '../pessoa/pessoa-projetos-ensinos/pessoa-projetos-ensinos.page';
import { UserProvider } from 'src/app/services/user/user';
import { PessoaProvider } from 'src/app/services/pessoa/pessoa';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AnotacaoListPage } from '../anotacao-list/anotacao-list.page';
import { AcompanhamentoPessoaPage } from '../acompanhamento/acompanhamento-pessoa/acompanhamento-pessoa.page';
import { MdaPessoaPage } from '../mda/mda-pessoa/mda-pessoa.page';
import { PessoaMigrarPage } from '../pessoa/pessoa-migrar/pessoa-migrar.page';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Browser } from '@capacitor/browser';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';

declare var instituicaoConstants: { IS_CATHOLIC: any; IS_CONVENCAO: any; BUSCAR_INTITUICOES: number; };

@Component({
  selector: 'app-participacoes',
  templateUrl: './participacoes.page.html',
  styleUrls: ['./participacoes.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NomenclaturaPipe,
    TranslateModule,
    LoadingSpinnerComponent,
  ],
})
export class ParticipacoesPage implements OnInit {
  pessoa: any = { contato: {}, endereco: {}, hasMda: {} };
  visitante: any;
  isVisitante: boolean;
  pessoaTipo = false
  idPessoa: any;
  meuCadastro = false;
  membro = false;
  editar = false;
  ddi: any;
  permissao: any;
  nomeUsuario: any;
  origemGrupos: boolean;
  public isCatholic = instituicaoConstants.IS_CATHOLIC;
  public isConvencao = instituicaoConstants.IS_CONVENCAO;
  public isControle = false;
  loaded = false;
  permissaoVisitante = false;
  permissaoFamiliares: any;
  isMobile: any = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    any: function () {
      return (this.isMobile.Android() || this.isMobile.iOS());
    }
  };

  constructor(
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public userProvider: UserProvider,
    public pessoaProvider: PessoaProvider,
    public loadingController: LoadingController,
    private translate: TranslateService,
  ) {
    this.membro = this.navParams.get('membro');
    this.permissao = this.navParams.get('permissao');
    this.permissaoVisitante = this.userProvider.hasPermissao('VISITANTE_VISUALIZAR');
    this.idPessoa = this.navParams.get('idPessoa');
    this.meuCadastro = this.navParams.get('meuCadastro');
    this.origemGrupos = this.navParams.get("origemGrupos");
    this.isVisitante = this.navParams.get("isVisitante");
    this.isControle = instituicaoConstants.BUSCAR_INTITUICOES == 2;
    this.permissaoFamiliares = this.meuCadastro ? 
      this.userProvider.hasConfig('210') : this.userProvider.hasConfig('176');

    this.pessoaProvider.getbyId(this.idPessoa).subscribe((data) => {
      this.pessoa = data;
      this.nomeUsuario = this.pessoa.nome.split(' ')[0]
      this.ddi = data.contato;

      if (!this.ddi) {
        this.ddi = "55"
      } else {
        this.ddi = data.contato.ddiTelCelular;
      }

      this.visitante = this.userProvider.hasConfig('160');

      if (!this.visitante && this.pessoa.idPessoaTipo == 5) {
        this.pessoaTipo = true;
      }

      if (this.visitante && this.pessoa.idPessoaTipo != 5 || !this.visitante) {
        this.pessoaTipo = true;
      }

      if (this.userProvider.hasPermissao('PESSOA_EDITAR') && this.pessoa.idPessoaTipo != 5) {
        this.editar = true;
      } else if (this.userProvider.hasPermissao('VISITANTE_EDITAR') && this.pessoa.idPessoaTipo == 5) {
        this.editar = true;
      } else if (this.meuCadastro) {
        this.editar = true;
      }

      // this.loader.dismiss();
      this.loaded = true;
    });
  }

  ngOnInit() {
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  public async familiares(idPessoa: any) {
    const data = { idPessoa: idPessoa, membro: this.membro }
    const modalPage = await this.modalCtrl.create({ component: ModalPessoaFamiliaresPage, componentProps: data })
    modalPage.present();
  }

  public async grupos(idPessoa: any) {
    var data = { idPessoa: idPessoa, tipo: 1 };
    const modalPage = await this.modalCtrl.create({ component: MeusGruposMinisteriosPage, componentProps: data });
    modalPage.present();
  }


  public async projetos(idPessoa: any) {
    const data = { idPessoa: idPessoa }
    const modalPage = await this.modalCtrl.create({ component: PessoaProjetosEnsinosPage, componentProps: data })
    modalPage.present();
  }

  public async contribuicoes(idPessoa: any) {
    const data = { idPessoa: idPessoa }
    const modalPage = await this.modalCtrl.create({ component: MinhasContribuicoesPage, componentProps: data })
    modalPage.present();
  }

  public async anotacoes() {
    const modalPage = await this.modalCtrl.create({ component: AnotacaoListPage })
    modalPage.present();
  }

  public async acompanhamentos(idPessoa: any) {
    const data = { idPessoa: idPessoa }
    const modalPage = await this.modalCtrl.create({ component: AcompanhamentoPessoaPage, componentProps: data });
    modalPage.present();
  }

  public async ministerios(idPessoa: any) {
    const data = { idPessoa: idPessoa, tipo: 2 }
    const modalPage = await this.modalCtrl.create({ component: MeusGruposMinisteriosPage, componentProps: data })
    modalPage.present();
  }

  public async mda(pessoa: any) {
    const data = { pessoa: pessoa, modal: true, modoReduzido: true }
    const modalPage = await this.modalCtrl.create({ component: MdaPessoaPage, componentProps: data })
    modalPage.present();
  }

  public async migrar(pessoa: any) {
    var data = { pessoa: pessoa, isVisitante: this.isVisitante };
    const modalPage = await this.modalCtrl.create({ component: PessoaMigrarPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data
    if (data) {
      this.pessoaProvider.getbyId(this.idPessoa).subscribe((data) => {
        this.pessoa = data;
      });
    }

  }

  trilho() {
    Browser.open({ url: 'https://integracao.prover.app/trilho-externo/' + this.pessoa.uuid });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
